module.exports = require("./ewo-CM.js");